import styles from '@buddieshr/styles/components/pageWrapper.module.scss';

const PageWrapper = ({
  children,
  width = 1140,
  style = {},
  className,
  classNameInner,
}) => (
  <div
    className={`${styles.wrapper}${className ? ` ${className}` : ''}`}
    style={{ width: `${width}px`, ...style }}
  >
    <div
      className={`${styles.inner}${classNameInner ? ` ${classNameInner}` : ''}`}
    >
      {children}
    </div>
  </div>
);

export default PageWrapper;
